import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
/*
  Generated class for the ApiProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ApiProvider {

  constructor(public http: Http) {
    console.log('Hello ApiProvider Provider');
  }

  getTrainingOverview(){
    return this.http.get('https://rheinoldstarsfunctions.azurewebsites.net/api/BSTestFunc').map(res => res.json());
  }

  saveEntity(tableName: string, partition: string, key: string, value: any){
    console.log("tableName: " + tableName);

    let myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');    
    let myParams = new URLSearchParams();
    myParams.append('tableName', tableName);
    myParams.append('partition', partition);
    myParams.append('key', key);	
    let options = new RequestOptions({ headers: myHeaders, params: myParams });

    var url = "https://rheinoldstarsfunctions.azurewebsites.net/api/Storage";

    return this.http.post(url, value, options)
      .map(res => res.json())
      .catch(this.handleErrorObservable);
  }

  updateEntity(tableName: string, partition: string, key: string, value: any){
    
    var logString = "tableName: " + tableName + " partition: " + partition + " key: " + key;  
    console.log(logString);

    let myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');    
    let myParams = new URLSearchParams();
    myParams.append('tableName', tableName);
    myParams.append('partition', partition);
    myParams.append('key', key);	
    let options = new RequestOptions({ headers: myHeaders, params: myParams });

    
    var url = "https://rheinoldstarsfunctions.azurewebsites.net/api/Storage";

    return this.http.put(url, value, options)
      .map(res => res.json())
      .catch(this.handleErrorObservable);
  }

  getEntity(tableName: string, partition: string){

    // return this.http.get('assets/testdata25102017/lineUp.json').map(res => res.json());
    

    let myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');    
    let myParams = new URLSearchParams();
    myParams.append('tableName', tableName);
    myParams.append('partition', partition);
    let options = new RequestOptions({ headers: myHeaders, params: myParams });

    var url = "https://rheinoldstarsfunctions.azurewebsites.net/api/Storage";
          return this.http.get(url, options)
            .map(res => res.json().reverse())
            .catch(this.handleErrorObservable);
  }

  deleteEntity(tableName: string, partition: string, key: string){
    let myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');    
    let myParams = new URLSearchParams();
    myParams.append('tableName', tableName);
    myParams.append('partition', partition);
    myParams.append('key', key);
    let options = new RequestOptions({ headers: myHeaders, params: myParams });

    var url = "https://rheinoldstarsfunctions.azurewebsites.net/api/Storage";
    
          return this.http.delete(url, options)
            .map(this.extractData)
            .catch(this.handleErrorObservable);
  }

  private extractData(res: Response) {
    //let body = res.json();
    //return body || {};
    return {};
  }
  
  private handleErrorObservable (error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.message || error);
  }
     
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts